import Metric from './component';

export default Metric;
